import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Clock, Sliders } from 'lucide-react';
import styles from './ConfigLayout.module.css';
import { useStore } from '../../../context/StoreContext';

export default function ConfigLayout() {
    const { activeStore } = useStore();
    const isHQ = activeStore?.isHQ || activeStore?.id === 'global_hq';

    const configTabs = [
        { id: 'eod', label: 'EOD Automation', icon: Clock, path: '/config/eod' }
    ];

    return (
        <div className={styles.layoutWrapper}>
            <div className={styles.innerSidebar}>
                <div className={styles.sidebarHeader}>
                    {/* Using Theme Variables for Icon Colors */}
                    <h1 className={styles.sidebarTitle}><Sliders size={16} color="var(--h-color-primary-600)" /> Configuration</h1>
                    <p className={styles.sidebarSubtitle}>{isHQ ? 'Global master settings.' : 'Branch specific settings.'}</p>
                </div>
                <div className={styles.navList}>
                    <div className={styles.navLabel}>Modules & Automations</div>
                    {configTabs.map(tab => {
                        const Icon = tab.icon;
                        return (
                            <NavLink key={tab.id} to={tab.path} className={({ isActive }) => `${styles.navItem} ${isActive ? styles.navItemActive : ''}`}>
                                <Icon size={14} strokeWidth={2.5} />{tab.label}
                            </NavLink>
                        );
                    })}
                </div>
            </div>
            <div className={styles.contentArea}>
                <Outlet />
            </div>
        </div>
    );
}